import { Box, Button, Typography, useTheme } from "@mui/material";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { renderHours } from "../../time-tracking/worktime";
import ExoAvatar from "../../../components/exo/ExoAvatar";
import { NavLink } from "react-router-dom";
import { tokens } from "../../../global/theme/tokens";

export const ActiveTimeTracking = ({ activeTime }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { t } = useTranslation();

  if (!activeTime) return;
  const currentMinutes =
    moment().diff(moment(activeTime.timeStart)) / (1000 * 60);
  const project = activeTime.project;
  const name = !project.clientType
    ? t("internal")
    : project.client
    ? project.clientType === "company"
      ? project.client.name
      : `${project.client.lastName} ${project.client.firstName}`
    : "";

  return (
    <Box className="w-full px-2 pb-2">
      <NavLink to={`/projects/management/${project.id}`}>
        <Button
          className="w-full"
          sx={{
            padding: "4px 8px",
            borderRadius: "8px",
            border: `1px solid ${colors.success}40`,
            bgcolor: colors.success + "15",
            ":hover": {
              borderColor: colors.success + "80",
              bgcolor: colors.success + "25",
            },
          }}
        >
          <Box className="flex items-center gap-2 w-full">
            {project.image ? (
              <img
                src={project.image.temporaryUrl}
                className="w-7 h-7 object-contain rounded"
              />
            ) : (
              <ExoAvatar
                picture={
                  project.client.logo && project.client.logo.temporaryUrl
                }
                type={project.clientType}
                name={name}
                size="28px"
              />
            )}
            <Box className="flex flex-col items-start min-w-0">
              <Typography
                fontSize={12}
                fontWeight={500}
                noWrap
                sx={{
                  maxWidth: "100%",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {project.name}
              </Typography>
              <Typography
                fontSize={10}
                className="monospace opacity-70"
                sx={{ color: colors.success }}
              >
                {`${t("since")} ${renderHours(currentMinutes)}h`}
              </Typography>
            </Box>
          </Box>
        </Button>
      </NavLink>
    </Box>
  );
};
